import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "ll-billed-status-select"
};
import { computed } from 'vue';
export default {
  __name: 'LlBilledStatusSelect',
  props: {
    modelValue: {
      type: [Object, String, null],
      default: null
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    labelClass: {
      type: String,
      default: ''
    },
    componentClass: {
      type: String,
      default: 'remove-outline'
    },
    placeholder: {
      type: String,
      default: 'Select Billed Status'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: 'billed-status-filter'
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Billed status options from ListsService
    const billedOptions = [{
      label: 'Billed',
      id: 'Final'
    }, {
      label: 'Draft',
      id: 'Interim'
    }, {
      label: 'WIP',
      id: 'WIP'
    }, {
      label: 'Not Billed',
      id: 'notFinal'
    }, {
      label: 'All',
      id: 'all'
    }];
    const handleChange = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.hideLabel ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(["py-1 text-sm", __props.labelClass])
      }, " Billed Status ", 2)) : _createCommentVNode("", true), _createVNode(_component_v_autocomplete, {
        "model-value": __props.modelValue,
        items: billedOptions,
        density: "compact",
        "item-title": "label",
        "item-value": "id",
        "return-object": __props.returnObject,
        variant: "outlined",
        "hide-details": __props.hideDetails,
        class: _normalizeClass(__props.componentClass),
        placeholder: __props.placeholder,
        clearable: __props.clearable,
        disabled: __props.disabled,
        "data-cy": __props.dataCy,
        "onUpdate:modelValue": handleChange
      }, null, 8, ["model-value", "return-object", "hide-details", "class", "placeholder", "clearable", "disabled", "data-cy"])]);
    };
  }
};